module.exports = __webpack_public_path__ + "img/btnright.8ab7e7c0.png";